import styled from 'styled-components';

// Note, Commented code above "Temp 7 days" needs to be readded
// commented code below "Temp 7 days" needs to be removed

export const AppointmentSchedulerStyles = styled.div`
  background-color: #3F5261;
  border-radius: 15px;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px #5f5f5f solid;
  max-height: 500px;
  margin: 0 auto;
  max-width: ${props => (props.mode === 'slideup' ? '750px' : '510px')};
  padding-bottom: 3rem;
  ${props => props.theme.media.md} {
    height: auto;
    margin-top: 0;
  }
  ${props => props.theme.media.lg} {
    max-width: 940px;
    max-height: 610px;
  }
  .calendar-title {
    color: ${props => props.theme.textColor};
    font-weight: 500;
    margin-bottom: 0;
    text-align: center;
  }
  .calendar-subtitle {
    color: ${props => props.theme.textColor};
    margin-bottom: 1rem;
    text-align: center;
  }
  .appointment-container {
    justify-content: center;
    margin: 0 auto;
    max-width: 750px;
    overflow-x: inherit;
    white-space: nowrap;
    ${props => props.theme.media.md} {
      overflow-x: hidden;
    }
    ${props => props.theme.media.lg} {
      max-width: 100%;
      max-height: 600px;
      overflow: hidden;
    }
    .appointment-details {
      display: none;
      ${props => props.theme.media.md} {
        display: block;
      }
      .appt-title {
        color: #5F5F5F;
        font-weight: 500;
        margin-bottom: 5px;
        ${props => props.theme.media.lg} {
          font-size: 1.5rem;
        }
      }
      .date,
      .time,
      .timezone {
        display: flex;
        > div {
          width: 1rem;
          > div {
            width: 1rem; /* handles ReactSVG nested divs */
          }
        }
        .small {
          color: ${props => props.theme.gray600};
          font-size: 0.775rem;
          margin-bottom: 0.5rem;
          margin-left: 0.5rem;
          line-height: 2.2;
        }
        svg {
          height: 1rem;
          width: 1rem;
          path {
            fill: #707070;
            stroke: none;
          }
        }
      }
    }
    .sub-title-desktop {
      display: none;
      ${props => props.theme.media.lg} {
        display: block;
        font-family: Inter;
        font-size: 18px;
        color: white;
        padding: 15px 0px;
        text-align: center;
      }
    }
  }
  .back-to-date-btn {
    display: none;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      &.show {
        align-items: center;
        align-self: flex-start;
        background-color: transparent;
        border: 1px solid ${props => props.theme.gray600};
        border-radius: 50%;
        color: ${props => props.theme.gray600};
        display: flex;
        height: fit-content;
        justify-content: center;
        margin-top: 1rem;
        padding: 5px;
        width: fit-content;
      }
    }
  }
  .accountant-details {
    display: none;
    ${props => props.theme.media.md} {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
    }
    .accountant-avatar {
      border-radius: 50%;
      height: auto;
      width: 80px;
    }
    .meeting-with {
      align-items: flex-start;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: 1rem;
      .top,
      .bottom {
        font-size: 0.875rem;
      }
      .top {
        font-weight: 500;
        line-height: 0.875rem;
      }
    }
  }
  .time-slot-btn-enter {
    opacity: 0;
  }
  .time-slot-btn-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }
  .time-slot-btn-exit {
    opacity: 1;
  }
  .time-slot-btn-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
  .calendar-loader-wrapper {
    position: fixed;
    top: 57.56px;
    left: 0;
    background-color: rgba(255, 255, 255, .85);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background-color: rgba(255, 255, 255, .25);
      backdrop-filter: blur(7px);
    }
  }
  .calendar-loader {
    width: auto;
    height: auto;
    max-width: 307.2px;
    max-height: 172.8px;
    ${props => props.theme.media.sm} {
      max-height: none;
      max-width: none;
    }
  }
  .calendar-loader-text {
    margin-bottom: 0;
    font-family: Poppins;
    font-size: 1rem;
    font-weight: 500;
    ${props => props.theme.media.md} {
      font-size: 1.15rem;
    }
  }
}
  .date-component-container {
    ${props => props.theme.media.lg} {
      display: flex;
      justify-content: center;
      width: 90%;
      height: 445px;
      margin: auto;
      padding: 10px 0px;
    }
  }
  .scheduler-selected-date {
    font-family: Poppins;
    font-weight: 600;
    font-size: 25px;
    color: #FFFFFF;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #96a0a8;
    text-align: center;
    ${props => props.theme.media.lg} {
    }
  }
  .date-selector-container {
    display: flex;
    flex-direction: column;
    
    .date-selector-wrapper {
      display: flex;
      flex-direction: row;
      margin-top: 14px;
      margin-bottom: 14px;
      // justify-content: center;
      // Temp 7 days
      overflow-y: scroll;
      // Temp 7 days
      ${props => props.theme.media.md} {
        justify-content: center;
      }
      
      ${props => props.theme.media.lg} {
        flex-direction: column;
        margin-right: 15px;
        margin-top: 15px;
        overflow-y: initial;
        //Temp 7 days
        overflow-y: initial;
      }
    }
    .date-selector-border {
      ${props => props.theme.media.lg} {
        position: relative;
        left: 17px;
      }
    }
    .date-selector-border.active-border {
      ${props => props.theme.media.lg} {
        position: relative;
        border: 1px solid white;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        border-right: 3px solid #3F5261;
        z-index: 2;
      }
    }
    .date-selector {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100px;
      margin: auto 4px;
      border-radius: 15px;
      cursor: pointer;
      color: white;
      border: 1px solid white;
      //min-height: 75px;
      // Temp 7 days
      min-height: 50px;
      ${props => props.theme.media.lg} {
        // margin: 15px;
        // Temp 7 days
        margin: 10px;
        min-height: 70px;
      }
      .date {
        font-family: Poppins;
        font-weight: 500;
        font-size: 22px;
        letter-spacing: 0px;
        text-align: center;
        // Temp 7 days
        ${props => props.theme.media.lg} {
          font-size: 18px;
        }
       }
      .day-name {
        font-family: Inter;
        text-align: center;
        
        font-size: 18px;
        // Temp 7 days
        ${props => props.theme.media.lg} {
          font-size: 18px;
        }
      }
    }
    .active {
      background-color: white; 
      color: #F15F22;
    }
  }
  .current-time-container {
    .current-time {
      font-family: Helvetica Neue;
      font-size: 16px;
      color: white;
      margin-bottom: 5px;
      text-align: center;
    }
    ${props => props.theme.media.lg} {
      display: none;
    }
  }
  .current-time-container.desktop {
    display: none;
    ${props => props.theme.media.lg} {
      display: block;
      margin-top: 5px;
    }
  }
  .time-container {
    position: relative;
    display: grid;
    grid-template-columns: 150px 150px;
    grid-gap: 1rem;
    justify-content: center;
    max-height: 286px;
    overflow-y: scroll;
    
    ${props => props.theme.media.lg} {
      grid-template-columns: 150px 150px 150px 150px;
      grid-gap: .5rem;
      height: 425px;
      overflow-y: visible;
      max-height: 100%;
      padding: 15px;
      border: 1px solid white;
      border-radius: 15px;
    }
    .time-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      color: #F15F22;
      cursor: pointer;
      height: 50px;
      border-radius: 8px;
      font-family: Inter;
      font-size: 18px;
    }
    .time-slot.active:hover {
      background-color: #F15F22;
      color: white;
    }
    .disabled {
      opacity: 40%;
      cursor: not-allowed;
    }
    .selected {
    }
    .hovered {
      background-color: #F15F22;
      color: white;
    }
  }
`;